const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StudioPromptCommandURL: any = {
    PostStudioPrompt: Backofficebff + '/v1/studio-prompts',
    PutStudioPrompt: Backofficebff + '/v1/studio-prompts',
    DeleteStudioPrompt: Backofficebff + '/v1/studio-prompts',
};

